import {Component, Injectable, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root'
})
export class GenericModalService {

  constructor(private modalService: BsModalService) { }

  showObjModalWithTemplate(templateRef: TemplateRef<any>, objInitialState: any, size: string = 'modal-lg') {
    const modalRef: BsModalRef = this.modalService.show(templateRef,
        { initialState: { objInitialState }, class: size, backdrop: 'static'});

    return modalRef;
  }


}
